/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import { SchemaSpecification } from './schema.specification';
import { WeeklyTrain }         from './weekly.train';

export class WeeklyTrainSchema extends SchemaSpecification {

  constructor() {

    super();

    this.jsonSpec = `{
      "train_weekly": {
        "schema": {
          "fields": [
            {
              "name": "train_id",
              "title": "client generated id for this train, must be unique within model",
              "type": "integer",
              "col": 1,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "name",
              "title": "human readable name of the train",
              "type": "string",
              "col": 2,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "train_class_id",
              "title": "client generated id for its category",
              "type": "integer",
              "col": 3,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "trains_per_week",
              "title": "Number of trains/week",
              "type": "float",
              "col": 4,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "distribution_table_id",
              "title": "Identification of Distribution table to apply to this train volume",
              "type": "string",
              "col": 5,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "link_from",
              "title": "array of link_id for origin link",
              "type": "integer array",
              "col": 6,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "link_to",
              "title": "array link_id for destination link",
              "type": "integer array",
              "col": 7,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "seed",
              "title": "randomization seed",
              "type": "integer",
              "col": 8,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "tonnage",
              "title": "total gross tonnage of the train",
              "type": "float",
              "col": 9,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "length",
              "title": "total length of the train in feet",
              "type": "float",
              "col": 10,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "priority",
              "title": "relative priority of train (higher better)",
              "type": "integer",
              "col": 11,
              "constraints": {
                "required": true
              }
            },
            {
              "name": "max_overtake_delay",
              "title": "maximum acceptable delay before forcing overtake (hours)",
              "type": "float",
              "col": 12,
              "constraints": {
                "required": true
              }
            }
          ],
          "primaryKey": "train_id"
        },
        "dataType": "table",
        "data": []
      }
}`;

    super.cache();
  }

  /** convert the given object to data table row, only properties that match field names will be created. */
  public override toRow(object: any): any[] {

    const train: WeeklyTrain = object as WeeklyTrain;

    if (!train._tc || !train._paths[0][0] || !train._paths[0][1]) {

      return [];
    }

    /* assume object is a WeeklyTrain and create an object that has fields compatible with this schema */

    const proxy: any = {
      train_id:              train._id,
      name:                  train._name,
      train_class_id:        train._tc._id,
      link_from:             [ train._paths[0][0]._id ],
      link_to:               [ train._paths[0][1]._id ],
      tonnage:               train._tonnage,
      length:                train._length,
      priority:              train._priority,
      max_overtake_delay:    train._overtake,
      distribution_table_id: train._distId,
      seed:                  train._seed,
      trains_per_week:       train._perWeek
    };

    /* now convert that */

    return super.toRow(proxy);
  }

  /** helper to insert weekly trains into a scenario train_weekly section, returns the full object, ready to be saved. */
  render(items: WeeklyTrain[]): any {

    /* create the data table */

    const d = this.dataTable(items);

    /* insert */

    const w: any = this.findObject('train_weekly', this.schemaObj);

    if (w === null) {

      this.lastError = `(render) problems finding train_weekly section: ${this.lastError}`;

      return null;
    }

    w['data'] = d;

    /* pass back the full rendered version, this version can be given to JSON.stringify() to save to file. */

    return this.schemaObj;
  }

}
